export default __webpack_public_path__ + "static/shoecoverreg-098e5d7a3d4f010b1fda242dd0577cf3.jpg";